import { render, staticRenderFns } from "./KeepInTouch2.vue?vue&type=template&id=1b23a1ca&scoped=true"
import script from "./KeepInTouch2.vue?vue&type=script&lang=js"
export * from "./KeepInTouch2.vue?vue&type=script&lang=js"
import style0 from "./KeepInTouch2.vue?vue&type=style&index=0&id=1b23a1ca&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b23a1ca",
  null
  
)

export default component.exports